import { useMemo } from 'react';
import { useAppSelector } from 'redux/hooks';
import { selectOrganizationData } from 'pages/redux';
import { getMaxStaffForOrganization, selectStaffSeatCount } from 'pages/Settings/redux';

export type StaffSeatsSnapshot = {
  used: number,
  maxStaff: number,
  remaining: number,
  atLimit: boolean,
  tone: 'warn' | 'critical' | null,
};

export const useStaffSeats = (): StaffSeatsSnapshot => {
  const organizationData = useAppSelector(selectOrganizationData);
  const staffSeatCount = useAppSelector(selectStaffSeatCount);

  return useMemo(() => {
    const maxStaff = getMaxStaffForOrganization(organizationData?.maxStaff);
    const used = Math.max(
      Number(staffSeatCount) || 0,
      Number(organizationData?.staffSeatCount) || 0,
    );
    const remaining = Math.max(0, maxStaff - used);
    const atLimit = used >= maxStaff;
    let tone: 'warn' | 'critical' | null = null;
    if (atLimit) tone = 'critical';
    else if (remaining <= 1) tone = 'warn';
    return { used, maxStaff, remaining, atLimit, tone };
  }, [organizationData?.maxStaff, organizationData?.staffSeatCount, staffSeatCount]);
};

export default useStaffSeats;
